import React, { useEffect } from "react";
import { Select } from "antd";
import { createComponentStore } from "easy-peasy";
import { Controller } from "react-hook-form";

export default function SearchHelp({
  model,
  searchParam,
  params,
  form,
  field,
  defaultValue,
  notFoundContent,
  objectInValue = true,
  optionTemplate = (item) => {
    return (
      <Select.Option key={item.id} value={item.id}>
        {item.desctiption}
      </Select.Option>
    );
  },
  ...props
}) {
  const useStore = createComponentStore(model);
  const [store, actions] = useStore();

  useEffect(() => {
    if (defaultValue)
      actions.setData(objectInValue ? [defaultValue] : [store.record]);
  }, [defaultValue, store.record]);

  useEffect(() => {
    if (!objectInValue && defaultValue) actions.fetch({ id: defaultValue });
  }, [objectInValue, defaultValue]);

  return (
    <Controller
      defaultValue={defaultValue}
      control={form.control}
      name={field}
      render={({ onChange, onBlur, name, value }) => (
        <Select
          {...props}
          className={props.readOnly ? "readOnly" : undefined}
          name={name}
          allowClear={true}
          disabled={props.disabled}
          value={value?.id || value}
          onBlur={onBlur}
          notFoundContent={notFoundContent}
          onChange={(value) => {
            if (objectInValue) value = store.data?.find((f) => f.id == value);
            onChange(value);
          }}
          showSearch
          filterOption={false}
          onSearch={(value) => {
            if (value.length)
              actions.searchHelp({
                [searchParam]: value,
                state: "ACTIVE",
                ...params,
              });
          }}
          style={{ width: "100%" }}
        >
          {store.data?.map((d) => {
            return optionTemplate(d);
          })}
        </Select>
      )}
    />
  );
}
